// Google Analytics helper functions

export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

// Property interactions
export const trackPropertyClick = (propertyTitle, propertyLocation, propertyPrice) => {
  trackEvent('property_click', {
    property_title: propertyTitle,
    property_location: propertyLocation,
    property_price: propertyPrice,
  });
};

// Button clicks
export const trackButtonClick = (buttonName, buttonLocation) => {
  trackEvent('button_click', {
    button_name: buttonName,
    button_location: buttonLocation,
  });
};

// Form interactions
export const trackFormStart = (formName) => {
  trackEvent('form_start', {
    form_name: formName,
  });
};

export const trackFormSubmit = (formName, formData = {}) => {
  trackEvent('form_submit', {
    form_name: formName,
    ...formData,
  });
};

export const trackFormError = (formName, errorMessage) => {
  trackEvent('form_error', {
    form_name: formName,
    error_message: errorMessage,
  });
};

// Navigation
export const trackNavigation = (sectionName) => {
  trackEvent('navigation_click', {
    section_name: sectionName,
  });
};

export const trackLanguageChange = (fromLanguage, toLanguage) => {
  trackEvent('language_change', {
    from_language: fromLanguage,
    to_language: toLanguage,
  });
};

// Cookie consent
export const trackCookieConsent = (consentType) => {
  trackEvent('cookie_consent', {
    consent_type: consentType, // 'accept' or 'decline'
  });
};

// Engagement
export const trackSectionView = (sectionName) => {
  trackEvent('section_view', {
    section_name: sectionName,
  });
};

export const trackCarouselInteraction = (action, slideIndex) => {
  trackEvent('carousel_interaction', {
    action: action, // 'next', 'prev', 'click'
    slide_index: slideIndex,
  });
};

// Engagement metrics
export const trackScrollDepth = (percentage) => {
  trackEvent('scroll_depth', {
    depth_percentage: percentage,
  });
};

export const trackTimeOnPage = (seconds) => {
  trackEvent('time_on_page', {
    duration_seconds: seconds,
  });
};

// Page visibility
export const trackPageVisibility = (isVisible) => {
  trackEvent('page_visibility', {
    is_visible: isVisible,
  });
};

